module.exports = __webpack_public_path__ + "67d05cb1892d2d717205b6c28e071da8.jpg";